import { Box, Grid } from "@mui/material";
import ImageLoader from "../components/ImageLoader";
import CustomText from "../components/CustomText";

const LaboratoryServices = () => {
  return (
    <Box sx={styles.container}>
      {/* HEADER */}
      <Grid container sx={styles.header}>
        <Grid size={styles.gridOne} />
        {/* Logo + título */}
        <Grid size={styles.grid7} sx={styles.headerLeft}>
          <ImageLoader
            src="https://dulab.com.mx/assets/dulab-logo-sUMgtMu4.png"
            width={{
              xs: "90%",
              sm: "90%",
              md: "90%",
              lg: 420,
            }}
          />
          <CustomText
            fontFamily="Nunito"
            color="#00518C"
            fontWeight="bold"
            textAlign="left"
            sx={styles.title}
          >
            Laboratorio Clínico
          </CustomText>
        </Grid>
        {/* Disponible 24 horas */}
        <Grid size={styles.grid10} />
        <Grid size={styles.grid4} sx={styles.headerRight}>
          <CustomText
            fontFamily="Nunito"
            color="#00518C"
            fontWeight="700"
            textAlign="center"
            sx={styles.Dispo}
          >
            Disponible las 24 horas del día
          </CustomText>
        </Grid>
      </Grid>
      {/* SERVICES */}
      <Grid container sx={styles.servicesContainer}>
        <Grid size={styles.gridOne} />
        {services.map((service, index) => {
          return (
            <Grid key={service.title} size={styles.grid2}>
              <Box sx={styles.Box}>
                <Box sx={styles.BoxImg}>
                  <ImageLoader
                    src={service.icon}
                    width={service.width}
                    height={service.height}
                  />
                </Box>
                <CustomText
                  fontFamily="Nunito"
                  color="#005A96"
                  fontWeight="bold"
                  textAlign="center"
                  sx={styles.Text}
                >
                  {service.title}
                </CustomText>
                <CustomText
                  fontFamily="Nunito"
                  color="#005A96"
                  fontWeight="300"
                  textAlign="center"
                  sx={styles.description}
                >
                  {service.description}
                </CustomText>
              </Box>
            </Grid>
          );
        })}
        <Grid size={styles.gridOne} />
      </Grid>
    </Box>
  );
};

export default LaboratoryServices;

const styles = {
  container: {
    backgroundColor: "#F4F6F8",
    py: {
      xs: 4,
      md: 5,
    },
    boxSizing: "border-box",
  },
  header: {
    alignItems: "center",
  },
  headerLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: {
      xs: "center",
      md: "flex-start",
    },
  },
  title: {
    fontSize: {
      xs: 35,
      md: 45,
    },
  },
  Text: {
    fontSize: {
      xs: 23,
      sm: 24,
      md: 30,
    },
    lineHeight: 1,
  },
  Dispo: {
    fontSize: {
      xs: 20,
      sm: 24,
      md: 20,
      lg: 28,
    },
    mt: 2,
    mb: 2,
  },
  headerRight: {
    display: "flex",
    borderRadius: "15px 0 0 15px",
    alignItems: "center",
    justifyContent: "center",
    mt: {
      xs: 3,
      md: 0,
    },
    backgroundColor: "#D9D9D9",
  },
  gridOne: { xs: 0.5, md: 1 },
  grid7: { xs: 12, md: 7 },
  grid4: { xs: 10, md: 4 },
  grid10: { xs: 2, md: 0 },
  grid2: { xs: 11, sm: 6, md: 4, lg: 2 },
  servicesContainer: {
    display: "flex",
    justifyContent: "center",
    mt: 2,
    px: {
      xs: 1,
      sm: 1.5,
      md: 0,
    },
  },
  BoxImg: {
    width: {
      xs: 90,
      md: 130,
    },
    height: {
      xs: 90,
      md: 130,
    },
    borderRadius: "50%",
    backgroundColor: "#E5EEF5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: {
      xs: 2,
      md: 2.5,
    },
  },
  Box: {
    display: "flex",
    width: "96%",
    minHeight: {
      xs: "auto",
      sm: 330,
      md: 370,
      lg: 370,
    },
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    boxSizing: "border-box",
    flexDirection: "column",
    alignItems: "center",
    px: { xs: 2, sm: 2.5, md: 2 },
    mb: { xs: 2, sm: 2.5, md: 0 },
    py: 3,
    cursor: "pointer",
    transition: "all 0.25s ease",
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
    },
  },
  description: {
    fontSize: {
      xs: 16,
      md: 18,
    },
    lineHeight: 1.25,
    mt: 1,
  },
};

const services = [
  {
    title: "Toma de\nmuestras",
    description:
      "Análisis clínicos con altos estándares de calidad para diagnósticos confiables y oportunos.",
    icon: "https://centromedicomedam.com/IMG/centromedicoMEDAM/tubo_Ensayo.svg",
    width: 55,
    height: 75,
  },
  {
    title: "Mastografía",
    description:
      "Estudio de rayos X que permiten identificar cambios o alteraciones mamarias para favorecer una detección oportuna.",
    icon: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Mastografo.svg",
    width: 50,
    height: 72,
  },
  {
    title: "Ultrasonido",
    description:
      "Estudios de ultrasonido para apoyo diagnóstico en distintas áreas médicas",
    icon: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Ultrasonido.svg",
    width: 55,
    height: 55,
  },
  {
    title: "Tomografía",
    description:
      "Tomografía computarizada de alta precisión para diagnósticos más detallados.",
    icon: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Tomografia.svg",
    width: 55,
    height: 55,
  },
  {
    title: "Rayos X",
    description: "Estudios de Rayos X digitales con alta resolución.",
    icon: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Radiografias.svg",
    width: 55,
    height: 55,
  },
];
